import { addFieldDefaults, assert, createOid, } from '@verdant-web/common';
/**
 * Exposes functionality for creating documents,
 * the only mutation which is available as an entry
 * point in the storage system.
 */
export class DocumentManager {
    constructor(meta, schema, entities) {
        this.meta = meta;
        this.schema = schema;
        this.entities = entities;
        this.getOid = (collection, init) => {
            const primaryKeyName = this.schema.collections[collection]
                .primaryKey;
            const primaryKey = init[primaryKeyName];
            assert(primaryKey, `Document must have a primary key: ${primaryKeyName.toString()} (got: ${JSON.stringify(init)})`);
            return createOid(collection, primaryKey);
        };
        this.addDefaults = (collectionName, init) => {
            const collection = this.schema.collections[collectionName];
            return addFieldDefaults(collection, init);
        };
        this.create = (collection, init, options = {}) => {
            const defaulted = this.addDefaults(collection, init);
            const oid = this.getOid(collection, defaulted);
            // documents are always objects at the root
            return this.entities.create(defaulted, oid, options);
        };
        this.delete = async (collection, primaryKey, options = {}) => {
            const oid = createOid(collection, primaryKey);
            return this.entities.delete(oid, options);
        };
        this.deleteAll = async (ids, options = {}) => {
            return this.entities.deleteAll(ids.map(([collection, primaryKey]) => createOid(collection, primaryKey)), options);
        };
        this.deleteAllFromCollection = async (collection, ids, options = {}) => {
            return this.entities.deleteAll(ids.map((primaryKey) => createOid(collection, primaryKey)), options);
        };
    }
}
//# sourceMappingURL=DocumentManager.js.map